{#if isShown}
  <div class="likelihood-container">
    <LikelihoodOptions
      disabledLikelihood={disabledLikelihood}
      selectedValue={selectedValue}
      suburb={suburb}
    />
    <div class="likelihood-callout-container">
      <div class="likelihood-callout">
          {#if tooltipText}
            {tooltipText}
          {:else}
            <h4>Did you know?</h4>
            <p>Floods that happen more often are smaller.</p>
            <p>Floods that happen rarely are much bigger.</p>
          {/if}
      </div>
      <span class="info-cirle">
        i
      </span>
    </div>
    {#if isFtus}
      <div class="likelihood-cta {stickyShowMap ? 'sticky' : ''}">
        <button class="button" disabled={selectedValue === ''} on:click={showMap}>Show on Map</button>
      </div>
    {/if}
  </div>
{/if}

<script>
import store, { STATES_MAIN, STATES_START } from "../../state";
import LikelihoodOptions from "./Options/Options.svelte";
LikelihoodOptions;
import utils from "../../utils";
export let isFtus;
export let isMobile;
export let stickyShowMap;
// html vars
let isShown = false;
let tooltipText;
let selectedValue = "";
let disabledLikelihood = true;
let suburb = "";
let likelihoodContainer;
// script vars
let mapViewSvc;
store.subscribe(state => {
    isShown = isFtus ? (isMobile ? state.splashHide : true) : true;
    if (state.riskProfile && state.riskProfile.Suburb !== suburb) {
        if (state.riskProfile.AOI === "IN") {
            suburb = state.riskProfile.Suburb || "";
            state.selectedLikelihood && setTooltip(state.selectedLikelihood.tooltip);
        }
        else {
            isShown = false;
        }
    }
    if (!mapViewSvc && state.mapViewService && state.mapViewService.isReady()) {
        mapViewSvc = state.mapViewService;
        disabledLikelihood = false;
    }
    if (mapViewSvc &&
        !disabledLikelihood &&
        state.selectedLikelihood &&
        selectedValue !== state.selectedLikelihood.value) {
        selectedValue = state.selectedLikelihood.value;
        selectFloodLikelihood(state.selectedLikelihood);
    }
});
function showMap() {
    store.update(state => {
        state.currentState = `${STATES_MAIN.START}.${STATES_START.DEFAULT}`;
        return state;
    });
}
function selectFloodLikelihood(selectedLikelihood) {
    //@ts-ignore
    mapViewSvc.setVisibleFloodLayer(selectedLikelihood.value);
    setTooltip(selectedLikelihood.tooltip);
}
function setTooltip(text) {
    tooltipText =
        suburb === "" ? `A ${text}` : `In ${utils.capitalize(suburb)}, a ${text}`;
}
</script>


<style>.likelihood-container{font-size:.875rem;min-height:350px;position:relative}.likelihood-callout-container{position:relative;padding-top:26px;margin-bottom:23px}.likelihood-callout-container .info-cirle{height:37px;width:37px;display:block;background-color:#f08403;text-align:center;display:flex;align-items:center;font-family:Times New Roman;font-size:24px;font-style:italic;line-height:27px;font-weight:700;border-radius:37px;position:absolute;top:8px;left:8px;justify-content:center;color:#fff}.likelihood-callout{padding:1.625rem 2.625rem;border:1px solid #1d3b78;border-radius:.5rem;font-size:.6875rem;line-height:15px;color:#363636;font-family:AvenirLT-Roman}.likelihood-callout h4{font-size:1rem;line-height:22px;color:#1d3b78;font-family:AvenirLT-Heavy}.likelihood-cta{background-color:#fff;position:fixed}.likelihood-cta.sticky{bottom:23px}.likelihood-cta .button{background-color:#f08403;color:#fff;font-size:12px;height:2.4rem;height:36px;width:120px;border-radius:4px;line-height:16px}.likelihood-cta .button:disabled{background-color:#a8a8a8}@media screen and (max-width:767px){.likelihood-cta.sticky{left:0;bottom:0;width:100%;padding:.5rem 2.1875rem}}</style>
